import { types } from 'mobx-state-tree';

const ProgramLearningFlow = types
	.model('ProgramLearningFlow', {
		id: types.number,
		study_direction: types.optional(types.string, ''),
		program_duration: types.optional(types.string, ''),
		entry_grade: types.optional(types.string, ''),
		grade: types.optional(types.string, ''),
		semester: types.optional(types.string, ''),
		sort_id: types.optional(types.number, 0),
	})
	.views(() => ({
		gradeToInt(grade?: string | null): number | null {
			const normalizedGrade = grade?.trim().toLowerCase();
			if (normalizedGrade === 'summer semester') {
				return 11.5;
			}

			const parsedGrade = Number.parseFloat(normalizedGrade || '');
			return Number.isNaN(parsedGrade) ? null : parsedGrade;
		},
	}));

export default ProgramLearningFlow;
